




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import GenericDropdown from '@/components/GenericDropdown.vue';                       // @ is an alias to /src
import LeaderboardLockedPlayerListComponent from '@/components/LeaderboardLockedPlayerListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { LeaderboardEntryForClient } from '@/Leaderboard'
import { IPaginationResult } from '@/PaginationResult'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src

@Component({
  name: 'LeaderboardLockedPlayer',
  components: { GenericDropdown, LeaderboardLockedPlayerListComponent, ModalWrapperComponent, MomentSelectorAndSorterComponent }
})

export default class LeaderboardLockedPlayerComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public lefcs: LeaderboardEntryForClient[] = []
  public paginationResult: IPaginationResult = null

  public playerID: number
  public playerName: string

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.playerName = player.label
    this.lefcs = []
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  public isTiedWithPreviousIndex(index: number): boolean {
    if (index === 0) return false
    if (this.lefcs.length === 0) return false
    return this.lefcs[index - 1].score === this.lefcs[index].score
  }  

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`LeaderboardTeamComponent.pathChanged() ${this.$route.path}`)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    utils_tracker.page(this.$options.name)

    // from url
    if (this.$route.query.playerID) this.playerID = Number(this.$route.query.playerID)

    const promises: Array<Promise<any>> = []

    if (this.playerID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDFromParent(this.playerID))

    promises.push(this.fetchData(false, this.pageNumberToLoadNext))

    await Promise.all(promises)

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add mode and flowAddress as query params to current url path
  private addParamsToURL() {
    if (!this.$route.path.includes('/player')) return
    let extra: string = ''
    if (this.playerID) {
      extra += `&playerID=${this.playerID}`
      extra = extra.replace('&', '?')     // replace only the first one
      this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
    }
  }

  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    if (!this.playerID) return 0

    // @ts-ignore
    const header: LeaderboardEntryForClient = {
      accountId: 'header',
    }

    let url: string = utils.getURLprefix() + `/api/topshot/leaderboards/playerLocked/${this.playerID}`;
    url += `?page=${pageNumberWhenCalled}`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`LeaderboardLockedPlayerComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;

    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the accounts
      let newRawItems: LeaderboardEntryForClient[] = response.data.lefcs
      if (newRawItems) {
        if (pageNumberWhenCalled === 1) this.lefcs = [ header ].concat(newRawItems)
        else this.lefcs = this.lefcs.concat(newRawItems)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    this.$store.commit("setLoading", { loading: false });
  }  
}
